import { kkmh } from "@/assets/js/common/kkmh_wk";
import doTrack from "./track";
import { showToast } from "./toast";
import { formatAxiosRes } from "./formate";
import jointImageSuffix from "@kkmh/image-format"; //引入的图片格式化sdk

let common = {
    install(Vue, opt) {
        Vue.prototype.$kkmh = kkmh;
        Vue.prototype.$doTrack = doTrack;
        Vue.prototype.$showToast = showToast;
        Vue.prototype.$formatAxiosRes = formatAxiosRes;
        Vue.prototype.$jointImageSuffix = jointImageSuffix;
    }
};

export { common }


// WEBPACK FOOTER //
// ./src/pages/act/202010/unit_member/js/common.js